import { render, staticRenderFns } from "./Amestecare.vue?vue&type=template&id=60650b94&scoped=true&"
import script from "./Amestecare.vue?vue&type=script&lang=js&"
export * from "./Amestecare.vue?vue&type=script&lang=js&"
import style0 from "./Amestecare.vue?vue&type=style&index=0&id=60650b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60650b94",
  null
  
)

export default component.exports